// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import LoadingSpinner from './LoadingSpinner';
import styles from './LoadingOverlay.module.scss';

const LoadingOverlay = ({ className }) => (
  <div
    className={classNames(
      'fixed-top d-flex flex-column w-100 h-100',
      styles.overlay,
      className,
    )}
    data-testid="loading-overlay"
  >
    <LoadingSpinner />
  </div>
);

LoadingOverlay.propTypes = {
  className: PropTypes.string,
};

LoadingOverlay.defaultProps = {
  className: null,
};

export default LoadingOverlay;
